import { CalendlyExpert } from "@/features/experts/types/CalendlyExpert";
import { ExpertRole } from "@/features/experts/types/ExpertRole";

export const mockedPsychologist: CalendlyExpert = {
  id: "mocked-psychologist-lucio-poletti",
  data: {
    name: "Lucio",
    family_name: "Poletti",
    address: "Via Roma 123, Milano",
    bio: "Psicologo esperto in terapia cognitivo-comportamentale",
    phone_number: "+39 123 456 7890",
    professional_order: "Ordine degli Psicologi",
    professional_order_number: "12345",
    professional_order_state: "Lombardia",
    sex: "Male" as any
  },
  calendly_data: {
    calendly_user: {
      avatar_url: "/images/assets/LucioPoletti.png",
      created_at: "2024-01-01T00:00:00Z",
      email: "lucio.poletti@example.com",
      name: "Lucio Poletti",
      scheduling_url: "https://calendly.com/lucio-poletti",
      slug: "lucio-poletti",
      timezone: "Europe/Rome",
      updated_at: "2024-01-01T00:00:00Z",
      uri: "https://api.calendly.com/users/lucio-poletti"
    },
    calendly_invitation_status: "active",
    calendly_invitation_uri: "https://calendly.com/lucio-poletti",
    uri: "https://api.calendly.com/users/lucio-poletti"
  },
  role: ExpertRole.Psychologist,
  email: "lucio.poletti@example.com",
  patients: [],
  tags: []
};

// You can add more mocked experts here
export const mockedExperts = {
  psychologist: mockedPsychologist,
  // nutritionist: mockedNutritionist,
  // physician: mockedPhysician,
}; 